import React from 'react';

import styles from './styles.module.scss';

export const Tag = ({
  children,
  color,
}: {
  children?: string;
  color?: string;
}) => {
  let style;
  switch (color) {
    case 'Teal': {
      style = styles.Teal;
      break;
    }
    case 'LightBlue': {
      style = styles.LightBlue;
      break;
    }
    case 'LighterBlue': {
      style = styles.LighterBlue;
      break;
    }
    case 'DarkGray': {
      style = styles.DarkGray;
      break;
    }
    case 'Indigo': {
      style = styles.Indigo;
      break;
    }
    case 'Orange': {
      style = styles.Orange;
      break;
    }
    case 'LightOrange': {
      style = styles.LightOrange;
      break;
    }
    case 'Green': {
      style = styles.Green;
      break;
    }
    case 'Gray': {
      style = styles.Gray;
      break;
    }
    case 'Neutral': {
      style = styles.Neutral;
      break;
    }
    case 'Yellow': {
      style = styles.Yellow;
      break;
    }
    case 'Brown': {
      style = styles.Brown;
      break;
    }
    case 'LgaBlue': {
      style = styles.LgaBlue;
      break;
    }
    case 'ErGreen': {
      style = styles.ErGreen;
      break;
    }
    case 'Red': {
      style = styles.Red;
      break;
    }
    case 'FeGreen': {
      style = styles.FeGreen;
      break;
    }
    case 'FeOlive': {
      style = styles.FeOlive;
      break;
    }
    case 'NoraPink': {
      style = styles.NoraPink;
      break;
    }
    case 'DodgerBlue': {
      style = styles.DodgerBlue;
      break;
    }
    case 'DarkGreen': {
      style = styles.DarkGreen;
      break;
    }
    case 'DarkBlue': {
      style = styles.DarkBlue;
      break;
    }
    case 'Coral': {
      style = styles.Coral;
      break;
    }
    case 'MediumSeaGreen': {
      style = styles.MediumSeaGreen;
      break;
    }
    case 'DarkScarlet': {
      style = styles.DarkScarlet;
      break;
    }
    case 'Maroon': {
      style = styles.Maroon;
      break;
    }
    case 'OliveDrab': {
      style = styles.OliveDrab;
      break;
    }
    case 'SteelBlue': {
      style = styles.SteelBlue;
      break;
    }
    case 'DeepSkyBlue': {
      style = styles.DeepSkyBlue;
      break;
    }
    case 'LightSkyBlue': {
      style = styles.LightSkyBlue;
      break;
    }
    case 'ForestGreen': {
      style = styles.ForestGreen;
      break;
    }
    case 'MediumAquamarine': {
      style = styles.MediumAquamarine;
      break;
    }
    case 'PaleGreen': {
      style = styles.PaleGreen;
      break;
    }
    case 'DarkOrange': {
      style = styles.DarkOrange;
      break;
    }
    case 'Gold': {
      style = styles.Gold;
      break;
    }
    case 'Chocolate': {
      style = styles.Chocolate;
      break;
    }
    case 'Peru': {
      style = styles.Peru;
      break;
    }
    case 'LightSeaGreen': {
      style = styles.LightSeaGreen;
      break;
    }
    case 'Turquoise': {
      style = styles.Turquoise;
      break;
    }
    case 'DarkOrchid': {
      style = styles.DarkOrchid;
      break;
    }
    case 'Orchid': {
      style = styles.Orchid;
      break;
    }
    case 'Lavender': {
      style = styles.Lavender;
      break;
    }
    case 'DarkViolet': {
      style = styles.DarkViolet;
      break;
    }
  }

  return (
    <span style={{ whiteSpace: 'nowrap' }} className={`${style} ${styles.Tag}`}>
      {children}
    </span>
  );
};
